import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=a7725c90&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=a7725c90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7725c90",
  null
  
)

export default component.exports